import { Injectable, Injector } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { RequestTokenService } from '../../../services/request-token.service';

/**
 * Quando o JWT venceu, a chamada sai sem Authorization e a API responde 401.
 * Lê o token guardado, pede outro e repete a chamada. Não recarrega a tela.
 */
@Injectable()
export class RenovarSessaoInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((erro: HttpErrorResponse) => {
        if (!this.deveRenovar(request, erro)) {
          return throwError(erro);
        }
        const tokens = this.injector.get(RequestTokenService);
        return tokens.renovarToken().pipe(
          switchMap((resultado) => {
            if (!resultado.isSuccess()) {
              return throwError(erro);
            }
            const autorizacao = tokens.createAuthorizationHeader().get('Authorization');
            if (!autorizacao) {
              return throwError(erro);
            }
            return next.handle(request.clone({ setHeaders: { Authorization: autorizacao } }));
          }),
        );
      }),
    );
  }

  private deveRenovar(request: HttpRequest<any>, erro: HttpErrorResponse): boolean {
    if (!(erro instanceof HttpErrorResponse) || erro.status !== 401) {
      return false;
    }
    if (request.url.includes('/Account/')) {
      return false;
    }
    const tokens = this.injector.get(RequestTokenService);
    return tokens.autorizacaoExpirada(request.headers.get('Authorization'));
  }
}
